import { Circle, Fill, Stroke, Style} from 'ol/style';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import 'ol/ol.css';
// import * as olColor from 'ol/color';
import GeoJSON from 'ol/format/GeoJSON';
import LayerGroup from 'ol/layer/Group';

export default class DIDZone{
    constructor(){
        this.map = null;
        this.styleFunction = (feature) => {
            const styles = {
                'Point': new Style({
                    image: new Circle({
                        radius: 10,
                        stroke: new Stroke({
                            color: 'rgba(52, 152, 219, 1.0)',
                            width: 5
                        }),
                        fill: new Fill({
                            color: 'rgba(52, 152, 219, 0.4)'
                        })
                    })
                }),
                'LineString': new Style({
                    stroke: new Stroke({
                        color: 'rgba(241, 196, 15, 0.6)',
                        width: 5
                    })
                }),
                'Polygon': new Style({
                    stroke: new Stroke({
                        color: 'rgba(255, 0, 0, 1.0)',
                        width: 2
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 0, 0, 0.4)'
                    })
                })
            };
            return styles[feature.getGeometry().getType()];
        };

        this.layerDIDZone = new LayerGroup({
            id: 'DIDZone',
            title: '人口集中地区',
            layers: []
        });
        
        // 外部GeoJSONソース設定
        // this.vectorSource = new VectorSource({
        //     url: 'https://afedrone-p-jp-s3-file-server.s3.ap-northeast-1.amazonaws.com/assets/A16-15_00_DID.geojson',
        //     format: new GeoJSON()
        // });
        
        // // 外部GeoJSONレイヤ設定
        // this.vectorLayer = new VectorLayer({
        //     id: 'DIDZone',
        //     source: this.vectorSource,
        //     style: this.styleFunction
        // });

    }

    init(map) {
        this.map = map;
        for (let i = 1; i < 48; i++) {

            const geojson_url = "https://afedrone-p-jp-s3-file-server.s3.ap-northeast-1.amazonaws.com/assets/A16-15_01-47_GML/".concat("A16-15_", ( '00' + i ).slice( -2 ), "_DID.geojson");
            // 外部GeoJSONレイヤ設定
            const vectorLayer = new VectorLayer({
                source: new VectorSource({
                           url: geojson_url,
                           format: new GeoJSON()
                        }),
                style: this.styleFunction,
            });
            this.layerDIDZone.getLayers().push(vectorLayer);
        }
        this.map.addLayer(this.layerDIDZone);
    }
    
        
}
